import { HttpContext, HttpContextToken, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Authentication } from './authentication';

export const AUTH_REQUIRED = new HttpContextToken<boolean>(() => false);

export const authContext = () => new HttpContext().set(AUTH_REQUIRED, true);

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!req.context.get(AUTH_REQUIRED)) {
    return next(req);
  }

  const auth = inject(Authentication);

  return from(auth.whenReady()).pipe(
    switchMap(() => from(auth.getIdToken())),
    switchMap((token) => {
      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
    }),
  );
};
